import {
  ModalProps as ChakraModalProps,
  Modal,
  ModalBody,
  ModalBodyProps,
  ModalCloseButton,
  ModalCloseButtonProps,
  ModalContent,
  ModalContentProps,
  ModalOverlay,
  ModalOverlayProps
} from "@chakra-ui/react"

// A wrapper around the Chakra Modal component
// Useful for import into the legacy client
// TODO: Add header and footer

interface ModalProps {
  children: React.ReactNode
  isOpen: boolean
  onClose: () => void
  modalProps: ChakraModalProps
  contentProps: ModalContentProps
  overlayProps: ModalOverlayProps
  bodyProps: ModalBodyProps
  closeProps: ModalCloseButtonProps
  showCloseButton?: boolean
}

const ChakraModal = ({
  children,
  showCloseButton = true,
  modalProps,
  contentProps,
  overlayProps,
  bodyProps,
  closeProps
}: ModalProps) => {
  return (
    <Modal {...modalProps}>
      <ModalOverlay {...overlayProps} />
      <ModalContent {...contentProps} className="ChakraModalContent">
        {showCloseButton && <ModalCloseButton {...closeProps} />}
        <ModalBody {...bodyProps}>{children}</ModalBody>
      </ModalContent>
    </Modal>
  )
}

// Mainly to silence console warnings when using ChakraModal with legacy ConnectStore.
ChakraModal.displayName = "ChakraModal"

export default ChakraModal
